import React, { useEffect, useState } from "react";
import Autocomplete from '@mui/material/Autocomplete';
import TextField from "@mui/material/TextField";

const countries = [
  { code: 'AD', label: 'Andorra', phone: '376', maxlength: '9' },
  { code: 'AE', label: 'United Arab Emirates', phone: '971', maxlength: '9' },
  { code: 'AF', label: 'Afghanistan', phone: '93', maxlength: '9' },
  { code: 'AG', label: 'Antigua and Barbuda', phone: '1-268', maxlength: '7' },
  { code: 'AI', label: 'Anguilla', phone: '1-264', maxlength: '7' },
  { code: 'AL', label: 'Albania', phone: '355', maxlength: '8' },
  { code: 'AM', label: 'Armenia', phone: '374', maxlength: '8' },
  { code: 'AO', label: 'Angola', phone: '244', maxlength: '9' },
  { code: 'AQ', label: 'Antarctica', phone: '672', maxlength: '6' },
  { code: 'AR', label: 'Argentina', phone: '54', maxlength: '10' },
  { code: 'AS', label: 'American Samoa', phone: '1-684', maxlength: '7' },
  { code: 'AT', label: 'Austria', phone: '43', maxlength: '10' },
  { code: 'AU', label: 'Australia', phone: '61', suggested: true, maxlength: '9' },
  { code: 'AW', label: 'Aruba', phone: '297', maxlength: '7' },
  { code: 'AX', label: 'Alland Islands', phone: '358', maxlength: '9' },
  { code: 'AZ', label: 'Azerbaijan', phone: '994', maxlength: '9' },
  { code: 'BA', label: 'Bosnia and Herzegovina', phone: '387', maxlength: '8' },
  { code: 'BB', label: 'Barbados', phone: '1-246', maxlength: '7' },
  { code: 'BD', label: 'Bangladesh', phone: '880', maxlength: '10' },
  { code: 'BE', label: 'Belgium', phone: '32', maxlength: '9' },
  { code: 'BF', label: 'Burkina Faso', phone: '226', maxlength: '8' },
  // Add more countries here in alphabetical order
  { code: 'BG', label: 'Bulgaria', phone: '359', maxlength: '9' },
  { code: 'BH', label: 'Bahrain', phone: '973', maxlength: '8' },
  { code: 'BI', label: 'Burundi', phone: '257', maxlength: '8' },
  { code: 'BJ', label: 'Benin', phone: '229', maxlength: '8' },
  { code: 'BL', label: 'Saint Barthélemy', phone: '590', maxlength: '9' },
  { code: 'BM', label: 'Bermuda', phone: '1-441', maxlength: '7' },
  { code: 'BN', label: 'Brunei Darussalam', phone: '673', maxlength: '7' },
  { code: 'BO', label: 'Bolivia', phone: '591', maxlength: '8' },
  { code: 'BQ', label: 'Bonaire', phone: '599', maxlength: '7' },
  { code: 'BR', label: 'Brazil', phone: '55', maxlength: '11' },
  { code: 'BS', label: 'Bahamas', phone: '1-242', maxlength: '7' },
  { code: 'BT', label: 'Bhutan', phone: '975', maxlength: '8' },
  { code: 'BV', label: 'Bouvet Island', phone: '', maxlength: '' },
  { code: 'BW', label: 'Botswana', phone: '267', maxlength: '8' },
  { code: 'BY', label: 'Belarus', phone: '375', maxlength: '9' },
  { code: 'BZ', label: 'Belize', phone: '501', maxlength: '7' },
  { code: 'CA', label: 'Canada', phone: '1', maxlength: '11' },
  { code: 'CC', label: 'Cocos Islands', phone: '61', maxlength: '9' },
  { code: 'CD', label: 'Democratic Republic of the Congo', phone: '243', maxlength: '9' },
  { code: 'CF', label: 'Central African Republic', phone: '236', maxlength: '8' },
  { code: 'CG', label: 'Republic of the Congo', phone: '242', maxlength: '9' },
  { code: 'CH', label: 'Switzerland', phone: '41', maxlength: '9' },
  { code: 'CI', label: 'Ivory Coast', phone: '225', maxlength: '8' },
  { code: 'CK', label: 'Cook Islands', phone: '682', maxlength: '5' },
  { code: 'CL', label: 'Chile', phone: '56', maxlength: '9' },
  { code: 'CM', label: 'Cameroon', phone: '237', maxlength: '8' },
  { code: 'CN', label: 'China', phone: '86', maxlength: '13' },
  { code: 'CO', label: 'Colombia', phone: '57', maxlength: '10' },
  { code: 'CR', label: 'Costa Rica', phone: '506', maxlength: '8' },
  { code: 'CU', label: 'Cuba', phone: '53', maxlength: '10' },
  { code: 'CV', label: 'Cape Verde', phone: '238', maxlength: '7' },
  { code: 'CW', label: 'Curaçao', phone: '599', maxlength: '7' },
  { code: 'CX', label: 'Christmas Island', phone: '61', maxlength: '9' },
  { code: 'CY', label: 'Cyprus', phone: '357', maxlength: '9' },
  { code: 'CZ', label: 'Czech Republic', phone: '420', maxlength: '9' },
  { code: 'DE', label: 'Germany', phone: '49', maxlength: '12' },
  { code: 'DJ', label: 'Djibouti', phone: '253', maxlength: '8' },
  { code: 'DK', label: 'Denmark', phone: '45', maxlength: '8' },
  { code: 'DM', label: 'Dominica', phone: '1-767', maxlength: '11' },
  { code: 'DO', label: 'Dominican Republic', phone: '1-809', maxlength: '11' },
  { code: 'DZ', label: 'Algeria', phone: '213', maxlength: '9' },
  { code: 'EC', label: 'Ecuador', phone: '593', maxlength: '9' },
  { code: 'EE', label: 'Estonia', phone: '372', maxlength: '8' },
  { code: 'EG', label: 'Egypt', phone: '20', maxlength: '10' },
  { code: 'EH', label: 'Western Sahara', phone: '212', maxlength: '9' },
  { code: 'ER', label: 'Eritrea', phone: '291', maxlength: '7' },
  { code: 'ES', label: 'Spain', phone: '34', maxlength: '9' },
  { code: 'ET', label: 'Ethiopia', phone: '251', maxlength: '9' },
  { code: 'FI', label: 'Finland', phone: '358', maxlength: '10' },
  { code: 'FJ', label: 'Fiji', phone: '679', maxlength: '7' },
  { code: 'FK', label: 'Falkland Islands', phone: '500', maxlength: '5' },
  { code: 'FM', label: 'Micronesia', phone: '691', maxlength: '7' },
  { code: 'FO', label: 'Faroe Islands', phone: '298', maxlength: '6' },
  { code: 'FR', label: 'France', phone: '33', maxlength: '10' },
  { code: 'GA', label: 'Gabon', phone: '241', maxlength: '8' },
  { code: 'GB', label: 'United Kingdom', phone: '44', maxlength: '11' },
  { code: 'GD', label: 'Grenada', phone: '1-473', maxlength: '11' },
  { code: 'GE', label: 'Georgia', phone: '995', maxlength: '9' },
  { code: 'GF', label: 'French Guiana', phone: '594', maxlength: '9' },
  { code: 'GG', label: 'Guernsey', phone: '44', maxlength: '10' },
  { code: 'GH', label: 'Ghana', phone: '233', maxlength: '9' },
  { code: 'GI', label: 'Gibraltar', phone: '350', maxlength: '8' },
  { code: 'GL', label: 'Greenland', phone: '299', maxlength: '6' },
  { code: 'GM', label: 'Gambia', phone: '220', maxlength: '7' },
  { code: 'GN', label: 'Guinea', phone: '224', maxlength: '8' },
  { code: 'GP', label: 'Guadeloupe', phone: '590', maxlength: '9' },
  { code: 'GQ', label: 'Equatorial Guinea', phone: '240', maxlength: '8' },
  { code: 'GR', label: 'Greece', phone: '30', maxlength: '10' },
  { code: 'GS', label: 'South Georgia and the South Sandwich Islands', phone: '', maxlength: '' },
  { code: 'GT', label: 'Guatemala', phone: '502', maxlength: '8' },
  { code: 'GU', label: 'Guam', phone: '1-671', maxlength: '11' },
  { code: 'GW', label: 'Guinea-Bissau', phone: '245', maxlength: '7' },
  { code: 'GY', label: 'Guyana', phone: '592', maxlength: '7' },
  { code: 'HK', label: 'Hong Kong', phone: '852', maxlength: '8' },
  { code: 'HM', label: 'Heard Island and McDonald Islands', phone: '', maxlength: '' },
  { code: 'HN', label: 'Honduras', phone: '504', maxlength: '8' },
  { code: 'HR', label: 'Croatia', phone: '385', maxlength: '9' },
  { code: 'HT', label: 'Haiti', phone: '509', maxlength: '8' },
  { code: 'HU', label: 'Hungary', phone: '36', maxlength: '9' },
  { code: 'ID', label: 'Indonesia', phone: '62', maxlength: '11' },
  { code: 'IE', label: 'Ireland', phone: '353', maxlength: '10' },
  { code: 'IL', label: 'Israel', phone: '972', maxlength: '9' },
  { code: 'IM', label: 'Isle of Man', phone: '44', maxlength: '10' },
  { code: 'IN', label: 'India', phone: '91', maxlength: '10' },
  { code: 'IO', label: 'British Indian Ocean Territory', phone: '246', maxlength: '7' },
  { code: 'IQ', label: 'Iraq', phone: '964', maxlength: '10' },
  { code: 'IR', label: 'Iran', phone: '98', maxlength: '11' },
  { code: 'IS', label: 'Iceland', phone: '354', maxlength: '7' },
  { code: 'IT', label: 'Italy', phone: '39', maxlength: '11' },
  { code: 'JE', label: 'Jersey', phone: '44', maxlength: '10' },
  { code: 'JM', label: 'Jamaica', phone: '1-876', maxlength: '11' },
  { code: 'JO', label: 'Jordan', phone: '962', maxlength: '9' },
  { code: 'JP', label: 'Japan', phone: '81', maxlength: '11' },
  { code: 'KE', label: 'Kenya', phone: '254', maxlength: '10' },
  { code: 'KG', label: 'Kyrgyzstan', phone: '996', maxlength: '9' },
  { code: 'KH', label: 'Cambodia', phone: '855', maxlength: '9' },
  { code: 'KI', label: 'Kiribati', phone: '686', maxlength: '5' },
  { code: 'KM', label: 'Comoros', phone: '269', maxlength: '7' },
  { code: 'KN', label: 'Saint Kitts and Nevis', phone: '1-869', maxlength: '11' },
  { code: 'KP', label: 'North Korea', phone: '850', maxlength: '10' },
  { code: 'KR', label: 'South Korea', phone: '82', maxlength: '10' },
  { code: 'KW', label: 'Kuwait', phone: '965', maxlength: '8' },
  { code: 'KY', label: 'Cayman Islands', phone: '1-345', maxlength: '11' },
  { code: 'KZ', label: 'Kazakhstan', phone: '7', maxlength: '11' },
  { code: 'LA', label: 'Laos', phone: '856', maxlength: '8' },
  { code: 'LB', label: 'Lebanon', phone: '961', maxlength: '8' },
  { code: 'LC', label: 'Saint Lucia', phone: '1-758', maxlength: '11' },
  { code: 'LI', label: 'Liechtenstein', phone: '423', maxlength: '9' },
  { code: 'LK', label: 'Sri Lanka', phone: '94', maxlength: '10' },
  { code: 'LR', label: 'Liberia', phone: '231', maxlength: '7' },
  { code: 'LS', label: 'Lesotho', phone: '266', maxlength: '8' },
  { code: 'LT', label: 'Lithuania', phone: '370', maxlength: '8' },
  { code: 'LU', label: 'Luxembourg', phone: '352', maxlength: '9' },
  { code: 'LV', label: 'Latvia', phone: '371', maxlength: '8' },
  { code: 'LY', label: 'Libya', phone: '218', maxlength: '9' },
  { code: 'MA', label: 'Morocco', phone: '212', maxlength: '9' },
  { code: 'MC', label: 'Monaco', phone: '377', maxlength: '9' },
  { code: 'MD', label: 'Moldova', phone: '373', maxlength: '8' },
  { code: 'ME', label: 'Montenegro', phone: '382', maxlength: '8' },
  { code: 'MF', label: 'Saint Martin', phone: '590', maxlength: '9' },
  { code: 'MG', label: 'Madagascar', phone: '261', maxlength: '9' },
  { code: 'MH', label: 'Marshall Islands', phone: '692', maxlength: '7' },
  { code: 'MK', label: 'North Macedonia', phone: '389', maxlength: '8' },
  { code: 'ML', label: 'Mali', phone: '223', maxlength: '8' },
  { code: 'MM', label: 'Myanmar', phone: '95', maxlength: '9' },
  { code: 'MN', label: 'Mongolia', phone: '976', maxlength: '8' },
  { code: 'MO', label: 'Macao', phone: '853', maxlength: '8' },
  { code: 'MP', label: 'Northern Mariana Islands', phone: '1-670', maxlength: '11' },
  { code: 'MQ', label: 'Martinique', phone: '596', maxlength: '9' },
  { code: 'MR', label: 'Mauritania', phone: '222', maxlength: '8' },
  { code: 'MS', label: 'Montserrat', phone: '1-664', maxlength: '11' },
  { code: 'MT', label: 'Malta', phone: '356', maxlength: '8' },
  { code: 'MU', label: 'Mauritius', phone: '230', maxlength: '7' },
  { code: 'MV', label: 'Maldives', phone: '960', maxlength: '7' },
  { code: 'MW', label: 'Malawi', phone: '265', maxlength: '9' },
  { code: 'MX', label: 'Mexico', phone: '52', maxlength: '13' },
  { code: 'MY', label: 'Malaysia', phone: '60', maxlength: '10' },
  { code: 'MZ', label: 'Mozambique', phone: '258', maxlength: '9' },
  { code: 'NA', label: 'Namibia', phone: '264', maxlength: '9' },
  { code: 'NC', label: 'New Caledonia', phone: '687', maxlength: '6' },
  { code: 'NE', label: 'Niger', phone: '227', maxlength: '8' },
  { code: 'NF', label: 'Norfolk Island', phone: '672', maxlength: '6' },
  { code: 'NG', label: 'Nigeria', phone: '234', maxlength: '10' },
  { code: 'NI', label: 'Nicaragua', phone: '505', maxlength: '8' },
  { code: 'NL', label: 'Netherlands', phone: '31', maxlength: '10' },
  { code: 'NO', label: 'Norway', phone: '47', maxlength: '8' },
  { code: 'NP', label: 'Nepal', phone: '977', maxlength: '10' },
  { code: 'NR', label: 'Nauru', phone: '674', maxlength: '7' },
  { code: 'NU', label: 'Niue', phone: '683', maxlength: '4' },
  { code: 'NZ', label: 'New Zealand', phone: '64', maxlength: '10' },
  { code: 'OM', label: 'Oman', phone: '968', maxlength: '8' },
  { code: 'PA', label: 'Panama', phone: '507', maxlength: '8' },
  { code: 'PE', label: 'Peru', phone: '51', maxlength: '9' },
  { code: 'PF', label: 'French Polynesia', phone: '689', maxlength: '6' },
  { code: 'PG', label: 'Papua New Guinea', phone: '675', maxlength: '7' },
  { code: 'PH', label: 'Philippines', phone: '63', maxlength: '10' },
  { code: 'PK', label: 'Pakistan', phone: '92', maxlength: '10' },
  { code: 'PL', label: 'Poland', phone: '48', maxlength: '9' },
  { code: 'PM', label: 'Saint Pierre and Miquelon', phone: '508', maxlength: '6' },
  { code: 'PN', label: 'Pitcairn', phone: '870', maxlength: '15' },
  { code: 'PR', label: 'Puerto Rico', phone: '1', maxlength: '11' },
  { code: 'PS', label: 'Palestinian Territory', phone: '970', maxlength: '10' },
  { code: 'PT', label: 'Portugal', phone: '351', maxlength: '9' },
  { code: 'PW', label: 'Palau', phone: '680', maxlength: '7' },
  { code: 'PY', label: 'Paraguay', phone: '595', maxlength: '9' },
  { code: 'QA', label: 'Qatar', phone: '974', maxlength: '8' },
  { code: 'RE', label: 'Réunion', phone: '262', maxlength: '9' },
  { code: 'RO', label: 'Romania', phone: '40', maxlength: '10' },
  { code: 'RS', label: 'Serbia', phone: '381', maxlength: '10' },
  { code: 'RU', label: 'Russia', phone: '7', maxlength: '11' },
  { code: 'RW', label: 'Rwanda', phone: '250', maxlength: '9' },
  { code: 'SA', label: 'Saudi Arabia', phone: '966', maxlength: '9' },
  { code: 'SB', label: 'Solomon Islands', phone: '677', maxlength: '5' },
  { code: 'SC', label: 'Seychelles', phone: '248', maxlength: '7' },
  { code: 'SD', label: 'Sudan', phone: '249', maxlength: '9' },
  { code: 'SE', label: 'Sweden', phone: '46', maxlength: '11' },
  { code: 'SG', label: 'Singapore', phone: '65', maxlength: '8' },
  { code: 'SH', label: 'Saint Helena', phone: '290', maxlength: '4' },
  { code: 'SI', label: 'Slovenia', phone: '386', maxlength: '8' },
  { code: 'SJ', label: 'Svalbard and Jan Mayen', phone: '47', maxlength: '8' },
  { code: 'SK', label: 'Slovakia', phone: '421', maxlength: '9' },
  { code: 'SL', label: 'Sierra Leone', phone: '232', maxlength: '8' },
  { code: 'SM', label: 'San Marino', phone: '378', maxlength: '10' },
  { code: 'SN', label: 'Senegal', phone: '221', maxlength: '9' },
  { code: 'SO', label: 'Somalia', phone: '252', maxlength: '7' },
  { code: 'SR', label: 'Suriname', phone: '597', maxlength: '7' },
  { code: 'SS', label: 'South Sudan', phone: '211', maxlength: '9' },
  { code: 'ST', label: 'Sao Tome and Principe', phone: '239', maxlength: '7' },
  { code: 'SV', label: 'El Salvador', phone: '503', maxlength: '8' },
  { code: 'SX', label: 'Sint Maarten', phone: '1-721', maxlength: '11' },
  { code: 'SY', label: 'Syria', phone: '963', maxlength: '9' },
  { code: 'SZ', label: 'Eswatini', phone: '268', maxlength: '8' },
  { code: 'TC', label: 'Turks and Caicos Islands', phone: '1-649', maxlength: '11' },
  { code: 'TD', label: 'Chad', phone: '235', maxlength: '8' },
  { code: 'TF', label: 'French Southern Territories', phone: '', maxlength: '' },
  { code: 'TG', label: 'Togo', phone: '228', maxlength: '8' },
  { code: 'TH', label: 'Thailand', phone: '66', maxlength: '10' },
  { code: 'TJ', label: 'Tajikistan', phone: '992', maxlength: '9' },
  { code: 'TK', label: 'Tokelau', phone: '690', maxlength: '4' },
  { code: 'TL', label: 'East Timor', phone: '670', maxlength: '7' },
  { code: 'TM', label: 'Turkmenistan', phone: '993', maxlength: '8' },
  { code: 'TN', label: 'Tunisia', phone: '216', maxlength: '8' },
  { code: 'TO', label: 'Tonga', phone: '676', maxlength: '5' },
  { code: 'TR', label: 'Turkey', phone: '90', maxlength: '11' },
  { code: 'TT', label: 'Trinidad and Tobago', phone: '1-868', maxlength: '11' },
  { code: 'TV', label: 'Tuvalu', phone: '688', maxlength: '5' },
  { code: 'TW', label: 'Taiwan', phone: '886', maxlength: '10' },
  { code: 'TZ', label: 'Tanzania', phone: '255', maxlength: '10' },
  { code: 'UA', label: 'Ukraine', phone: '380', maxlength: '12' },
  { code: 'UG', label: 'Uganda', phone: '256', maxlength: '9' },
  { code: 'UM', label: 'United States Minor Outlying Islands', phone: '', maxlength: '' },
  { code: 'US', label: 'United States', phone: '1', maxlength: '11' },
  { code: 'UY', label: 'Uruguay', phone: '598', maxlength: '8' },
  { code: 'UZ', label: 'Uzbekistan', phone: '998', maxlength: '9' },
  { code: 'VA', label: 'Vatican', phone: '379', maxlength: '10' },
  { code: 'VC', label: 'Saint Vincent and the Grenadines', phone: '1-784', maxlength: '11' },
  { code: 'VE', label: 'Venezuela', phone: '58', maxlength: '10' },
  { code: 'VG', label: 'British Virgin Islands', phone: '1-284', maxlength: '11' },
  { code: 'VI', label: 'U.S. Virgin Islands', phone: '1-340', maxlength: '11' },
  { code: 'VN', label: 'Vietnam', phone: '84', maxlength: '10' },
  { code: 'VU', label: 'Vanuatu', phone: '678', maxlength: '5' },
  { code: 'WF', label: 'Wallis and Futuna', phone: '681', maxlength: '6' },
  { code: 'WS', label: 'Samoa', phone: '685', maxlength: '5' },
  { code: 'YE', label: 'Yemen', phone: '967', maxlength: '9' },
  { code: 'YT', label: 'Mayotte', phone: '262', maxlength: '9' },
  { code: 'ZA', label: 'South Africa', phone: '27', maxlength: '11' },
  { code: 'ZM', label: 'Zambia', phone: '260', maxlength: '9' },
  { code: 'ZW', label: 'Zimbabwe', phone: '263', maxlength: '9' },
];


const MobileOtp = (props) => {
  const [phoneValue, setPhoneValue] = useState("");

  const handePhoneVal = (e) => {
    setPhoneValue(e.target.value);
  };
  // Getting value and passing the value through props
  props.setPhoneNo(phoneValue);

  const [selectedCountryCode, setSelectedCountryCode] = useState("");

  const handleCountryChange = (event, option) => {
    if (option) {
      setSelectedCountryCode(option.phone);
    } else {
      setSelectedCountryCode("");
    }
  };
  props.setCountryCode(`+${selectedCountryCode}`);

  return (
    <div className="row d-flex gap-4">
      <div className="sign-up-input p-2 d-flex">
        <div style={{ width: "120px", borderRight: "1px dashed #000" }}>
          <Autocomplete
            options={countries}
            getOptionLabel={(option) =>
              typeof option === "string"
                ? option
                : `${option.code} +${option.phone}`
            }
            onChange={(e, newValue) => handleCountryChange(newValue)}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="standard"
                InputProps={{
                  ...params.InputProps,
                  sx: {
                    "&:before, &:after": { borderBottom: "none" }, // remove underline
                  },
                }}
              />
            )}
          />
        </div>

        <input
          required
          autoComplete="off"
          id="countryInput"
          type="text"
          // maxLength={defaultCode ? defaultCode.maxlength : undefined} 
          placeholder="Mobile No"
          className="pl-10"
          onChange={handePhoneVal}
        />
      </div>

      {/* <div className="sign-up-input d-flex">
        <span style={{ width: "120px", borderRight: "1px dashed #000" }}>

          <select
            required
            id="countryInput"
            // className="sign-up-select"
            onChange={handleCountryChange}
          >
            <option value="">IN +91 </option>

            {countries.map((country) => (
              <option
                key={country.code}
                value={country.code}
                className="select-options"
              >
                {`${country.code}   +${country.phone}`}
              </option>
            ))}
          </select>
        </span>

        <input
          required
          autoComplete="off"
          id="countryInput"
          type="text"
          placeholder={
            getCountryInfo(selectedCountryCode)
              ? "Mobile No"
              : "+971 - Mobile No"
          }
          className="pl-10"
          onChange={handePhoneVal}
        />
      </div> */}

      {/* <select
        required
        id="countryInput"
        className="sign-up-select"
        onChange={handleCountryChange}
      >
        <option value="">Select Country</option>

        {countries.map((country) => (
          <option
            key={country.code}
            value={country.code}
            className="select-options"
          >
            {`${country.label}, ${country.code}, ${country.phone}`}
          </option>
        ))}
      </select> */}
    </div>
  );
};

export default MobileOtp;
